import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
// import { environment as env} from '../../../../../../environments/environment';
import { environment as env} from '../../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));

        //If para que não seja incluido o nosso token e que utilize o token informado nas chamadas da API
        if (request.url.includes(env.baseApiUrlCashBack) || request.url.includes(env.baseApiUrlPix)){
            console.log('');
        }
        else if (currentUser && currentUser.token && !request.headers.has('Authorization')) {
            request = request.clone({
                setHeaders: { 
                    Authorization: `Bearer ${currentUser.token}`
                }
            });
        }
        return next.handle(request);
    }
}